import { useEffect } from "react";
import styles from "./page.module.css";
import { sendAuthCode } from "@/api/auth";
import { useUserContext } from "@/contexts/UserContext";
import { useLocation, useSearch } from "wouter";
import { ErrorCode } from "@boxem/core-api-schema";
import Alert from "@/components/Alert/Alert";

export default function SellerApiConnectSucceedPage() {
  const [location, navigate] = useLocation();
  const searchParams = new URLSearchParams(useSearch());
  const code = searchParams.get("spapi_oauth_code");
  const sellerId = searchParams.get("selling_partner_id");
  const { user, setUser, hasTriedToGetUserFromLocalStorage } = useUserContext();

  if (!code) {
    navigate("~/connect/seller-api?failed=true&message=Missing%20auth%20code");
  }

  useEffect(() => {
    if (hasTriedToGetUserFromLocalStorage) {
      const redirectUri = encodeURIComponent(`${window.location.origin}/connect/seller-api/succeed`);

      sendAuthCode({ code, sellerId, redirectUri,  })
        .then(result => {
          setUser({...user, ...result }, false);
          navigate("~/");
        })
        .catch((e) => {
          console.error("Error in sending auth code:", e);
          const error = e[0]?.type === ErrorCode.SELLER_ID_IN_USE ? e[0].type : ErrorCode.GENERIC;
          navigate(`~/connect/seller-api?failed=true&error=${error}`);
        });
    }
  }, [code, hasTriedToGetUserFromLocalStorage]);

  return (
    <div className={styles.container}>
      <Alert type="success" message="Authentication succeeded." />
      <span>Saving OAuth connection status...</span>
    </div>
  );
}
